module.exports = __webpack_public_path__ + "img/bin.57ab75d5.svg";